import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCircleArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 17V15H16V17H8ZM12 14.4142L8.58579 11L10 9.58579L11 10.5858V7H13V10.5858L14 9.58579L15.4142 11L12 14.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleArrowDown;
